import { Component, View } from 'angular2/core';
import { Router, RouterLink } from 'angular2/router';
import { CORE_DIRECTIVES, FORM_DIRECTIVES } from 'angular2/common';

let template = require('./main.html');
let styles = require('./main.css');

@Component({
  selector: 'main'
})
@View({
  directives: [RouterLink, CORE_DIRECTIVES, FORM_DIRECTIVES ],
  template: template,
  styles: [ styles ],
})
export class Main {
  constructor(public router: Router) {
  }
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/layout/main/main.ts
 **/